import Icon from '../components/Icon.vue'

Icon.register({"wpforms":{"width":1536,"height":1792,"paths":[{"d":"M515 911v128h-252v-128h252zM515 656v127h-252v-127h252zM1273 1167v128h-341v-128h341zM1273 911v128h-672v-128h672zM1273 656v127h-672v-127h672zM1408 1516v-1240q0-8-6-14t-14-6h-32l-378 256-210-171-210 171-378-256h-32q-8 0-14 6t-6 14v1240q0 8 6 14t14 6h1240q8 0 14-6t6-14zM553 406l185-150h-406zM983 406l221-150h-406zM1536 276v1240q0 62-43 105t-105 43h-1240q-62 0-105-43t-43-105v-1240q0-62 43-105t105-43h1240q62 0 105 43t43 105z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wpforms.js
// module id = 1892
// module chunks = 0